import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { RestrictedToAdmin } from "components/auth";
import Card from "components/card";
import DataGrid, { DataGridItem } from "components/data-grid";
import FormTextField from "components/form/form-textfield";
import { PartnerSelect, UserSelect } from "components/select";
import { ContractSelect } from "../../../../components/select";

const NewCustomerForm = ({ intl, values, handleChange }) => (
  <>
    <DataGridItem big>
      <FormTextField
        type="text"
        id="description"
        name="description"
        value={values.description}
        onChange={handleChange}
        label={intl.formatMessage({ id: "common.description" })}
      />
    </DataGridItem>
    <DataGridItem big>
      <ContractSelect
        multiple
        id="contractIds"
        name="contractIds"
        label={intl.formatMessage({ id: "customer.contracts" })}
        handleChange={handleChange}
        value={values.contractIds}
        contractsWithoutCustomer
      />
    </DataGridItem>
    <DataGridItem big>
      <UserSelect
        excludePartnerUsers
        multiple
        isInsideForm
        id="userIds"
        name="userIds"
        label={intl.formatMessage({ id: "customer.users" })}
        onChange={handleChange}
        value={values.userIds}
      />
    </DataGridItem>
    <RestrictedToAdmin excludePartners>
      <Card>
        <DataGrid>
          <DataGridItem>
            <Typography variant="h6">
              <FormattedMessage id="app.page.user.associateToPartner" />
            </Typography>
            <PartnerSelect
              id="partnerId"
              name="partnerId"
              isInsideForm
              label={intl.formatMessage({ id: "app.partner" })}
              onChange={name => value => handleChange(name)(value)}
              value={values.partnerId}
            />
          </DataGridItem>
        </DataGrid>
      </Card>
    </RestrictedToAdmin>
  </>
);

NewCustomerForm.propTypes = {
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  handleChange: PropTypes.func,
};

export default injectIntl(NewCustomerForm);
